import {useState, useEffect, useMemo} from 'react';
import Table from '../table';
import ActionBar from '../actionBar';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import {dateFormatter} from '../dateFormatter';
import {useAtomValue} from 'jotai';
import {pageSizeRecoil} from '../recoil';
import {useLocation} from 'react-router-dom';
import {useSearch, useSort} from '../../lib/useQueryModifiers';
import {modelFormatter} from '../devices/columnFormatters';

export const WhitelistAssignments = props => {
  const {state:{whitelist_ssid_list_id, title}} = useLocation();  
  const [search, setSearch] = useSearch();
  const [sort, setSort] = useSort();
  const [pageNum, setPageNum] = useState(1);
  const [totalRecordsState, setTotalRecordsState] = useState(0);
  const pageSize = useAtomValue(pageSizeRecoil);

  const devicesFilters = useMemo(() => ({
    combineAnd: [
      ...search,
      ...sort,
      { field: "with.product_type", value: "1" },
      { field: "with.reported_firmware", value: "1" },
      { field: "with.user", value: "1" },
      { field: "whitelist_ssid_list_id", value: `${whitelist_ssid_list_id}` },
      { field: "search.fields", value: `serial_number` },
      { field: "search.fields", value: `user.firstname` },
      { field: "search.fields", value: `user.lastname` },
      { field: "options.page.num", value: `${pageNum}` },
      { field: "options.page.len", value: `${pageSize}` }
    ]
  }), [search, sort, whitelist_ssid_list_id, pageNum, pageSize]);

  const {data,loading} = useQuery(DEVICES, 
    {
      variables: { filters: devicesFilters },      
      skip: !sort.length
    });

  const totalQueried = data?.Devices?.metadata?.page?.records ?? totalRecordsState;
  const assignments = data?.Devices?.result || [];
  
  useEffect(()=> {
    setTotalRecordsState(totalQueried);
  }, [totalQueried]);

  useEffect(() => {
    return setPageNum(1)
  }, [search]);
    
  const columns = [
    { dataField: 'id', hidden: true },
    { dataField: 'user.firstname', text: 'First Name' },
    { dataField: 'user.lastname', text: 'Last Name' },
    { dataField: 'user.username', text: 'User ID' },
    { dataField: 'product_type.description', text: 'Model', formatter: modelFormatter },
    { dataField: 'serial_number', text: 'SAFECASE SERIAL NO.' },
    { dataField: 'reported_firmware.version', text: 'Firmware Version' },
    { dataField: 'modified_at', text: 'Last Updated (UTC)', sort: true, formatter: dateFormatter, hidden: true }
  ];
  
  return (
    <>
      <div className="sticky-top">
        <ActionBar showHidden={false} searchChange={setSearch} title={title} />
      </div>
      <Table
        testId="ssid-whitelist-assignments-table"
        columns={columns}
        data={assignments}
        loading={loading}
        pageSize={pageSizeRecoil}
        pageNum={pageNum}
        setPageNum={setPageNum}
        totalRecords={totalRecordsState}
        setSort={setSort}
        disableRowClick={true}
      />
    </>
  );
};

const DEVICES = gql`
  query getDevices($filters: GenericFilters!) {
    Devices (filters: $filters) {
      result {
        id
        device_model_id
        serial_number
        whitelist_ssid_list_id
        is_active
        modified_at
        user { id username firstname lastname }
        product_type_id
        product_type { id description greyhound_family samsung_family whippethusky_family }
        reported_firmware { id version description }
      }
      metadata { page { num len total inPage records } }
    }
  }
`;

export default WhitelistAssignments;
